// @ts-nocheck
// classes
import User from '../classes/User'

// state
import user from "../state/user"


const useAuth = (): {
    $user: User,
    $auth: {
        createUser: (data: {username: string, email: string, password: string, confirmPassword: string}) => Promise<void>,
        updateUser: (data: {username: string, attributes: any}) => Promise<void>,
        login: (data: {username: string, password: string}) => Promise<void>,
        refresh: () => Promise<void>,
        logout: () => Promise<void>,
        authRequest: () => Promise<void>,
        init: () => Promise<void>,
    }
} => {
    const $user: User = user
    const $auth = {
        createUser: async (data: {username: string, email: string, password: string, confirmPassword: string}) => await user.createUser(data),
        updateUser: async (data: {username: string, attributes: any}) => await user.updateUser(data),
        login: async (data: {username: string, password: string}) => await user.login(data),
        refresh: async () => await user.refresh(),
        logout: async () => await user.logout(),
        authRequest: async () => await user.authRequest(),
        init: async () => await user.init(),
    }


    return {
        $user,
        $auth,
    }
}

export default useAuth